import { VMContentItem } from '../vm_models';

export class VMTip {
  id: string;
  content: VMContentItem;
  weight: string;
}
